<div [ngSwitch]="isRead">
    <div *ngSwitchCase="true">
        <div class="form-group">
            <span class="label">Personnalité: </span>{{personnage?.background?.personnalite}}
        </div>          
        <div class="form-group">
            <span class="label">Concept: </span>{{personnage?.background?.concept}}
        </div>              
        <div class="form-group">
            <span class="label">But à court terme: </span>{{personnage?.background?.butCourtTerme}}
        </div>        
        <div class="form-group">
            <span class="label">But à moyen terme: </span>{{personnage?.background?.butMoyenTerme}}
        </div>        
        <div class="form-group">
            <span class="label">But à long terme: </span>{{personnage?.background?.butLongTerme}}
        </div>
        <div class="form-group">
            <span class="label">Historique: </span>{{personnage?.background?.historique}}
        </div>        
        <button (click)="switchMode()" class="btn btnPrimary">Modifier</button>
    </div>
    <div *ngSwitchCase="false">
        <form [formGroup]="backgroundForm" (ngSubmit)="onSubmit()">
          <div class="form-group">
            <label for="personnalite">Personnalité : </label>
            <textarea formControlName="personnalite" class="form-control"></textarea>
          </div>          
          <div class="form-group">
            <label for="concept">Concept : </label>
            <textarea formControlName="concept" class="form-control"></textarea>
          </div>              
          <div class="form-group">
            <label for="butCourtTerme">But à court terme : </label>
            <textarea formControlName="butCourtTerme" class="form-control"></textarea>
          </div>        
          <div class="form-group">
            <label for="butMoyenTerme">But à moyen terme : </label>
            <textarea formControlName="butMoyenTerme" class="form-control"></textarea>
          </div>        
          <div class="form-group">
            <label for="butLongTerme">But à long terme : </label>
            <textarea formControlName="butLongTerme" class="form-control"></textarea>
          </div>
          <div class="form-group">
            <label for="historique">Historique: </label>
            <textarea formControlName="historique" class="form-control"></textarea>
          </div>  
          <input type="submit" value="Confirmer" class="btn btnPrimary mt-3" >
        </form>
    </div>
</div>